module.exports = __webpack_public_path__ + "img/tipoCargos.266c521c.svg";